import { render, staticRenderFns } from "./ImportantKnowledge.vue?vue&type=template&id=0310a968&scoped=true&"
import script from "./ImportantKnowledge.vue?vue&type=script&lang=js&"
export * from "./ImportantKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310a968",
  null
  
)

export default component.exports